import Lottie from 'react-lottie-player';
import PageNotFoundJson from '../assets/lottie/PageNotFound.json';

export default function PageNotFound() {
  const containerStyles = {
    width: '100%',
    margin: '0 auto',
    height: 'calc(100vh - 14.8rem)',
  };
  return <Lottie loop animationData={PageNotFoundJson} play style={containerStyles} />;
}
